import { createSelector } from 'reselect';

const supplierTagsStateSelector = state => state.supplierTags;
const selectById = (state,itemId) => itemId 

export const supplierTagsSelector = createSelector(
    [supplierTagsStateSelector],
    supplierTags => supplierTags.items,
);

export const supplierTagsAsLabelAndValueSelector = createSelector(
  [supplierTagsSelector],
  tags => tags.map(({_id , name}) => ({
    name ,
    _id
  }))
)

export const supplierTagByIdSelector = createSelector(
  [supplierTagsSelector, selectById],
  (supplierTags, _id) => {
    const tag = supplierTags.find(item => _id === item._id)
    if(!tag) return null
    return tag
  }
)

export const supplierTagsIsLoadingSelector = createSelector(
    [supplierTagsStateSelector],
    supplierTags => supplierTags.isLoading,
);

export const supplierTagsCountSelector = createSelector(
  [supplierTagsStateSelector],
  supplierTags => supplierTags.count
)

export const searchValueSelector = createSelector(
  [supplierTagsStateSelector],
  supplierTags => supplierTags.searchValue
)




